import Select from '@atlaskit/select';
import React, { FC } from 'react';

export interface DecisionSelectOption {
  label: string;
  value: string;
  id: string;
  ssamContainer: string;
}
interface DecisionSelectProps {
  options: DecisionSelectOption[];
  onChange: (selectedDecision: DecisionSelectOption) => void;
  disabled?: boolean;
}

const DecisionSelect: FC<DecisionSelectProps> = ({ options, onChange, disabled = false }) => {
  return (
    <Select
      inputId="decision-key-select"
      options={options}
      isDisabled={disabled}
      onChange={(item) => onChange?.(item as DecisionSelectOption)}
      classNamePrefix="decision-select"
      placeholder="Select request type"
    />
  );
};

export default DecisionSelect;
